import { useEffect, useState } from 'react';
import { doorForAddress } from '../../lib/signInDoors';
import { NEUTRAL_BRANDING, loadBrandBySlug } from '../../lib/signInBranding';

let shownBrand = NEUTRAL_BRANDING;

function currentDoorBrand() {
    return doorForAddress(window.location);
}

// The welcome sequence opens with whatever brand the sign-in screen was wearing.
export function lastShownBrand() {
    return shownBrand;
}

export default function useSignInBrand() {
    const door = currentDoorBrand();
    const [brand, setBrand] = useState(() => door.brand);
    useEffect(() => {
        const current = currentDoorBrand();
        const slug = current.slug;
        setBrand(current.brand);
        if (!slug) return undefined;
        const controller = new AbortController();
        loadBrandBySlug(slug, controller.signal).then((loaded) => {
            setBrand({ ...current.brand, ...loaded, brand_name: current.brand.brand_name });
        }).catch((error) => {
            if (error.name !== 'AbortError') console.warn(error.message);
        });
        return () => controller.abort();
        // Sign-in branding is selected by the initial address; subsequent app navigation stays in the same door.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => { shownBrand = brand; }, [brand]);
    return brand;
}
